import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  min-height: 0;
  height: 100%;
`;

export const Title = styled.h1`
  color: #181818;
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
`;

export const ContentScroller = styled.div.attrs({
  "data-testid": "content-scroll",
} as Record<string, string>)`
  min-height: 0;
  flex: 1 1 auto;
  overflow: auto;
  padding-right: 16px;
`;

export const RowIcon = styled.span`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 4px;
  color: #7c7f7e;
  transition: color 0.2s ease;

  & i {
    font-size: 13px;
  }

  &::after {
    content: "Detail";
    position: absolute;
    left: 50%;
    bottom: calc(100% + 8px);
    z-index: 10;
    transform: translateX(-50%);
    display: none;
    box-sizing: border-box;
    width: 50px;
    height: 24px;
    padding: 2px 6px;
    border-radius: 4px;
    background: #181818;
    color: #ffffff;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    white-space: nowrap;
    pointer-events: none;
  }

  &:hover::after {
    display: block;
  }

  &:hover {
    color: #065fa6;
  }
`;

export const WrappingCell = styled.span`
  display: inline-block;
  max-width: 100%;
  white-space: normal;
  overflow-wrap: anywhere;
`;
